import * as AF from "src/types/formTemplate";

export function findQuestionByKey(
  formTemplate: AF.V3.FormTemplate,
  questionKey: string
): AF.V3.Question | undefined {
  let question: AF.V3.Question | undefined = undefined;

  for (const section of formTemplate.sections) {
    if ("questions" in section) {
      question = section.questions.find(
        (question) => question.key === questionKey
      );
    }

    if (question) {
      return question;
    }
  }

  return undefined;
}

export function findQuestionById(
  formTemplate: AF.V3.FormTemplate,
  questionId: string
): AF.V3.Question | undefined {
  let question: AF.V3.Question | undefined = undefined;

  for (const section of formTemplate.sections) {
    if ("questions" in section) {
      question = section.questions.find(
        (question) => question.id === questionId
      );
    }

    if (question) {
      return question;
    }
  }

  return undefined;
}

export function findSectionById(
  formTemplate: AF.V3.FormTemplate,
  sectionId: string
): [AF.V3.Section, number] | [undefined, undefined] {
  const index = formTemplate.sections.findIndex(
    (section) => section.id === sectionId
  );
  const section = formTemplate.sections[index];
  if (!section) {
    return [undefined, undefined];
  }

  return [section, index];
}
